'use client'
import * as React from 'react'
import { useTranslations } from 'next-intl'
import { ArrowRightIcon } from 'primitives/icons/arrows'

import { useConfig } from '../../_hooks/use-config'

const ListItem = ({ copy }: { copy: string }) => {
  return (
    <li className="flex gap-[10px]">
      <div className="flex w-4 py-1">
        <div className="flex h-4 items-center justify-center rounded-full bg-[#E2D9F2] p-1">
          <ArrowRightIcon className="size-2 text-[#4D134B]" />
        </div>
      </div>
      <p className="text-14 text-cf-black w-full">{copy}</p>
    </li>
  )
}

export function FreeTrialProductDetails({
  subscriptionType,
}: {
  subscriptionType: 'all_access' | 'ai_studio'
}) {
  const t = useTranslations('pages.b.product_details')

  const { pricePerMonth, pricePerMonthFull, currency } = useConfig(
    subscriptionType === 'ai_studio' ? 'freeTrialAiStudio' : 'freeTrialYearly',
  )

  const formattedPricePerMonth = `${currency?.symbol}${pricePerMonth}`
  const formattedPricePerMonthFull = `${currency?.symbol}${pricePerMonthFull}`

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full">
        <div className="flex w-full flex-row shadow-[0px_2px_10px_0px_rgba(0,_0,_0,_0.25)]">
          <div className="flex w-full flex-col rounded-r px-6 py-3 pb-[44px]">
            <div className="flex w-full flex-col justify-between gap-3">
              <h3 className="text-12 md:text-16 font-bold">
                {t('variants.free_trial.title', {
                  subscriptionName:
                    subscriptionType === 'ai_studio'
                      ? t('subscription_names.ai_studio')
                      : t('subscription_names.all_access'),
                })}
              </h3>
              <ul className="flex flex-col gap-3">
                <ListItem
                  copy={
                    subscriptionType === 'ai_studio'
                      ? t('variants.free_trial.items.ai_studio_1')
                      : t('variants.free_trial.items.1')
                  }
                />
                <ListItem copy={t('variants.free_trial.items.2')} />
                <ListItem
                  copy={t(
                    subscriptionType === 'ai_studio'
                      ? 'variants.free_trial.items.ai_studio_3'
                      : 'variants.free_trial.items.3',
                    {
                      price: formattedPricePerMonth,
                      fullPrice: formattedPricePerMonthFull,
                    },
                  )}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
